import { NavLink } from "react-router-dom";
import { RouteLink } from "../../types/route-link";
import { ADMIN, SUPER_ADMIN, USER } from "../../constants/role";
import superAdminRouteLinks from "./routeLinks/superAdminRouteLinks";
import adminRouteLinks from "./routeLinks/adminRouteLinks";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  selectIsNavbar,
} from "../../selectors/layoutSelectors";
import "./sidebar.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { setNavbar, setWidgetExpand } from "state/layoutSlice";
import EndUserRoutes from "./components/EndUserRoutes";

const Sidebar = () => {
  const role = localStorage.getItem("role") ?? "";
  const isNavbar = useAppSelector(selectIsNavbar);
  const dispatch = useAppDispatch();

  const toggleNavbar = (isCollapse: boolean) => {
    dispatch(setNavbar(true));
    dispatch(setWidgetExpand(isCollapse));
  };

  function createLinks(routes: Array<RouteLink>) {
    return routes.map((item, key) => {
      return (
        <div key={key}>
          <li className="nav-item my-1">
            <NavLink
              to={item.path}
              className={({ isActive }) =>
                isActive ? "active link-opacity-10" : ""
              }
            >
              <span
                className="itemList"
                style={{ flexDirection: isNavbar ? "row" : "column" }}
              >
                {item.icon && (
                  <FontAwesomeIcon
                    icon={item.icon}
                    style={{ color: "#c9ced6" }}
                    title={item.name}
                  />
                )}
                <p>{item.name}</p>
              </span>
            </NavLink>
          </li>
        </div>
      );
    });
  }

  function renderRouteLinks() {
    switch (role) {
      case SUPER_ADMIN:
        return createLinks(superAdminRouteLinks);
      case ADMIN:
        return createLinks(adminRouteLinks);
      case USER:
        return (
          <>
            <EndUserRoutes createLinks={createLinks} toggleNavbar={toggleNavbar} />
          </>
        );
      default:
        return <></>;
    }
  }

  return (
    <>
      <div
        className="navbar_aside"
        style={{ width: isNavbar ? "160px" : "100px" }}
      >
        <div className="navbar-wrapper">
          <div className="navbar-content">
            <ul className="nav nav-primary pt-1">{renderRouteLinks()}</ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
